module.exports = __webpack_public_path__ + "static/img/no_good_selected.6e06fb59.png";